module.exports = __webpack_public_path__ + "static/img/4.82739687.png";